<template>
  <div class="manage">
    <div class="part part1">
      <div @click="$router.push('/manage/order/orderManage')">
        <span><img src="../../assets/img/work/manage/manage_order.png" alt="">订单管理</span>
        <span><van-icon name="arrow" /></span>
      </div>
      <div @click="$router.push('/manage/buyer/buyerManage')">
        <span><img src="../../assets/img/work/manage/manage_buyer.png" alt="">买家管理</span>
        <span><em>
          <!-- 分享买家对账单、还款 -->
          </em><van-icon name="arrow" /></span>
      </div>
    </div>
    <div class="part part2" @click="$router.push('/manage/owner/ownerManage')">
      <span><img src="../../assets/img/work/manage/manage_owner.png" alt="">货主管理</span>
      <span><em>
        <!-- 分享货主对账单 -->
        </em><van-icon name="arrow" /></span>
    </div>
    <!-- <div class="part part2" @click="$router.push('/manage/stock/stockManage')">
      <span><img src="../../assets/img/work/manage/manage_stock.png" alt="">库存管理</span>
      <span><van-icon name="arrow" /></span>
    </div> -->

     <div class="part part1">
     
      <div @click="$router.push('/manage/stock/stockManage')">
        <span><img src="../../assets/img/work/manage/manage_stock.png" alt="">库存管理</span>
        <span><em>
          <!-- 分享买家对账单、还款 -->
          </em><van-icon name="arrow" /></span>
      </div>
       <div @click="$router.push('/manage/goods/goodsManage')">
        <span><img src="../../assets/img/work/manage/goods_manage.png" alt="">商品分类</span>
        <span><van-icon name="arrow" /></span>
      </div>
    </div>
   
     <div class="part part2" @click="$router.push('/manage/purchase/purchaseManage')">
      <span><img style="width:0.46rem;height:0.46rem;margin-right:0.29rem" src="../../assets/img/work/manage/manage_purchase.png" alt="">进货管理</span>
      <span><van-icon name="arrow" /></span>
    </div>
    <div class="part part2"  @click="$router.push('/manage/sale/saleManage')">
      <span><img src="../../assets/img/work/manage/manage_sale.png" alt="">销售统计</span>
      <span><van-icon name="arrow" /></span>
    </div>
  </div>
</template>

<script>
import { logout } from '@/api/login'
import { removeToken } from '@/utils/auth'
import { numFun } from '@/utils/index'
import { getType } from '@/utils/auth'
export default {
  name: 'manage',
  data(){
    return {
    }
  },
  filters:{
    formateNum :function(s){
      return numFun(s)
    }
  },
  created(){
  },
  mounted(){
  },
  methods:{
    
  }
}
</script>

<style lang="less" scoped>
.manage{
  min-height: calc(100vh - 50px);
  overflow: hidden;
  .part{
    margin-top: 0.2rem;
    background-color: #fff;
    font-size: 0.42rem;
    color: #333333;
    padding: 0 0.21rem; 
    img{
      width: 0.42rem;
      height: 0.42rem;
      margin-right: 0.33rem;
      vertical-align: sub;
    }
  }
  .part1{
    >div{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 1.4rem;
    }
    >div:first-child{
      border-bottom: 0.01rem solid #E5E5E5;
    }
  }
  .part2{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 1.4rem;
  }
  em{
    font-size: 0.28rem;
    color: #999999;
  }
  .van-icon{
    vertical-align: middle;
  } 
}
</style>